import { Component, OnInit } from '@angular/core';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO} from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';


@Component({
  selector: 'app-chapter-admin',
  templateUrl: './chapter-admin.component.html',
  styleUrls: ['./chapter-admin.component.css']
})
export class ChapterAdminComponent implements OnInit {
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
  email: any;
  workId: any;
  user: string = null;
  role: string = null;
  roleName: string = null;
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any;
  loginUserId: string;
  chapterId: number;
  createdBy: any;
  createdDateTime: any;
  modifiedBy: any;
  modifiedDateTime: any;
  userId: any;
  adminId: any;
  numberOfElements:number;
  currentPage:number = 0;
  currentNumberOfElements:number = ConstantValues.pageLimit;
  totalPages:number = 0;
  roleList : any;
  tableShow: any;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  searchTerm : any;
  siteData: any;
  siteList: any;
  selectedBpgsData: any;
  bpgList: any;
  selectedSiteId: any;
  selectedBpgId: any;
  selectedSite: any;
  siteAndPath: any;
  selectedBpg: any;
  allBpgIds: any[]=[];
  landingData:any;
  loginUserAdminId: any;
  tableresp : boolean;
  bpgNotSelected : boolean;
  userNotSelected : boolean;
  roleNotSelected :boolean;
  loginDetails:any;
  loginDataDetails:any;
  userAndRoleIdDTO:any
  
  chapterList: any;
  chapterIds:any;
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;
  leadAdminId:any
  bpgId :any;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;
  constructor(private userService: SelfService, 
    private adminService: BpgAdminServices, 
    private spinner: Ng4LoadingSpinnerService,
    
    private bpgCommonService: BpgCommonService,
    private bpgEventsService : BpgEventsService,
    private router: Router,
    private environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod'){
      if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {
        this.router.navigate(['/log-out']);
        }
    }

    if (localStorage.getItem('logOutFlag') == "true"){
      localStorage.clear();
      sessionStorage.clear();
        this.router.navigate(['/log-out']); 
        localStorage.setItem("logOutFlag","true");
     
    }

    if(localStorage.getItem('isbpgAdmin') == 'true')
    {
      this.isbpgAdmin = true
     }
     if(localStorage.getItem('isbpgLeadAdmin') === 'true')
     {
       this.isbpgLeadAdmin = true;
      }
      console.log(this.isbpgLeadAdmin)
    this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));
    localStorage.removeItem('searchedEventsCaledarItems');
    this.leadAdminId = localStorage.getItem('leadAdminId');
    if(this.leadAdminId  === 'true' && !this.isbpgAdmin)
    {
      localStorage.setItem('adminId','2');  

    }
    this.userAndRoleIdDTO = {
      userId: this.loginDataDetails['userId'],
      roleId: localStorage.getItem('adminId')
    }
    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    this.adminId = localStorage.getItem('adminId');
    if(this.adminId !== '1' && (this.adminId !== '2' && this.leadAdminId !== 'true'))
    {
      this.router.navigate(['/site-home']);
    }

    // if(this.loginDetails == null){
    //   this.router.navigate(['/login']);
    // }
    this.spinner.show();
    sessionStorage.removeItem("MembershipData");
    this.selectedSiteId = localStorage.getItem('userSiteId');
    this.loginUserAdminId = localStorage.getItem('adminId');
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.createdBy = this.loginData.userId;
    this.modifiedBy = this.loginData.userId;
    
    // if(this.loginUserAdminId === '2' || this.isbpgLeadAdmin){
    //   console.log("adminId "+this.loginUserAdminId)
    //   this.getSiteName();   
    //   this.getBpgList(); 

  
    // }
    if(this.loginUserAdminId === '1' || this.loginUserAdminId === '2' || this.isbpgLeadAdmin){
    this.getSiteList();
    this.getBpgList();    
    }
    
    this.landingDto = {
      "filter": { },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.LandingPaginationDTO.sortProperty = "user_first_name";
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    console.log(this.loginUserAdminId)
   if(this.loginUserAdminId === '1'){
    this.roleList =[
      {"roleName":"BPG Admin",
       "roleId":3
      },
      { "roleName":"BPG Lead Admin",
       "roleId":2
      }
    ]
   } 

   if(this.loginUserAdminId === '2' || this.isbpgLeadAdmin){
    this.roleList =[
      {"roleName":"BPG Admin",
       "roleId":3
      }
    ]
   }  
  
  
    this.createdDateTime = new Date();
    this.modifiedDateTime = new Date();

//     if(this.adminId ==2){
//       this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
//         this.chapterList = data;
//         for (let i = 0; i < this.chapterList.length; i++) {
//           if (i == 0) {
//             this.chapterIds = this.chapterList[i].chapterId;
//           }
//           else {

//             this.chapterIds = this.chapterIds +","+ this.chapterList[i].chapterId;
//           }
//         }
//         this.spinner.show();
//     this.listAdmins();
//   })
// }
// else
// {
//   this.spinner.show();
//   this.listAdmins();
// }
    this.loginUserId = this.loginData.userId;
    if(window.innerWidth<767){
      this.tableresp = true;
    }else{
      this.tableresp = false;
    }
    
    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);
  
  }
/** get site name in the dropdown for lead admin
  * @class ChapterAdminComponent
  * @method getSiteName
  */
  getSiteName(){
    this.selectedSite = this.loginData.site.siteName; 
    this.selectedSiteId = localStorage.getItem('userSiteId');  
  }

/** get site list in the dropdown
  * @class ChapterAdminComponent
  * @method getSiteList
  */
 getSiteList(){
   if(this.adminId === '1')
   {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
   }
   if(this.adminId === '2' || this.isbpgLeadAdmin)
   {
    this.siteData = {
      "filter": { "adminId":this.loginUserAdminId,
      "userId": this.createdBy},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
   }
  
  this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
    this.siteList = data;
    //filter default site from sitelist
    this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT'); 
    if(this.siteList != null){
      for(var i=0;i<this.siteList.length;i++){
        if(this.siteList[i].siteId == this.selectedSiteId ){
          this.selectedSite = this.siteList[i].siteName;
        }
      }
    }
  });
 }

/** get bpg list in the dropdown
  * @class ChapterAdminComponent
  * @method getBpgList
  */
 getBpgList(){
 this.selectedBpgsData =
      {
        "filter": {
          "siteId": this.selectedSiteId,
          "adminId":this.loginUserAdminId,
          "userId": this.createdBy,
          "isLeadAdmin":this.leadAdminId
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": "string",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "string",
        "uid": "string"
      }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      if(this.bpgList != null){
        console.log("bpgsLIst " + JSON.stringify(this.bpgList))
        for(var i=0;i<this.bpgList.length;i++){
          if (i == 0) {
            this.bpgId = this.bpgList[i].bpgId;
          }
          else {
            this.bpgId = this.bpgId +","+ this.bpgList[i].bpgId;
          }
        }
        }
      this.listAdmins();

      if(this.bpgList.length != 0){
      //this.bpgList.unshift({bpgId: 0, bpgName: 'Select All'});
      }else{
      this.bpgList.unshift({bpgId: 0, bpgName: 'No Data found'});
      }
      if(this.bpgList != null){
        this.bpgList.unshift({bpgId: 0, bpgName: '--Select BPG--'});
        for(var i=0;i<this.bpgList.length;i++){
          this.allBpgIds.push(this.bpgList[i].bpgId);
          if(this.bpgList[i].bpgId == this.selectedBpgId ){
            this.selectedBpg = this.bpgList[i].bpgName;            
          }
        }   
      }
    });
  } 
  /** get chapter id 
  * @class ChapterAdminComponent
  * @method getChapterIds
  */
  getChapterIds(){
    this.landingData = {
      "filter":{"bpgId":this.selectedBpgId,
      "siteId": this.selectedSiteId
        },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
     this.userService.getChapterByBpg(this.landingData).subscribe(data => {
      if(data!=null){
        for(var i=0;i<data.length;i++){
          this.chapterId = data[i];
        }
      }   
     });
  }
 
  /** to list admins in table
  * @class ChapterAdminComponent
  * @method listAdmins
  */
 

 listAdmins() {
    console.log("bpgs" + JSON.stringify(this.bpgId))
  this.timeOutError = false;
  this.spinner.show();
  this.LandingPaginationDTO.filter={"createdBy":this.createdBy,
  "adminId":this.loginUserAdminId,
  // "chapterId":this.chapterIds,
    "bpgId":this.bpgId,
   "siteId":this.selectedSiteId };
   this.adminService.getAllChapterAdmins(this.LandingPaginationDTO).subscribe(data => {    
   this.adminData = data.content; 
   if (this.adminData.length == 0) {
      this.tableShow = false;
      this.noDataFound = true;
	  setTimeout(function () {
        this.spinner.hide();
      }.bind(this), 100);

    } else {
      this.tableShow = true;
      this.noDataFound = false;
      setTimeout(function () {
        this.spinner.hide();
      }.bind(this), 5000);
      
    }
    this.numberOfElements = data.totalElements;
  },
  err => {
    console.log(JSON.stringify(err.value.message));
    if(err.value.statusText == ConstantValues.unknownError){
      this.timeOutError = true;
    }
  });
  
}

/** to list users other than admins
  * @class ChapterAdminComponent
  * @method getUserList
  */

 getUserList() {
  this.timeOutError = false;
  this.landingDto.filter = {"siteId": this.selectedSiteId,
                            "bpgId": this.selectedBpgId,
                            "leadershipPosition":"EMPLOYEE"};

  this.userService.getUserDropDown(this.landingDto).subscribe(data => {
    this.userList = data; 
    this.userList.map((i) => { i.userFirstName = i.userFirstName + ' ' + i.userLastName; return i; })
  }, err => {
    console.log(JSON.stringify(err.value.message));
    if(err.value.statusText == ConstantValues.unknownError){
      this.timeOutError = true;
    }
  });
}

 /** When select a user Populate the user details such as email and workId 
* @class ChapterAdminComponent
* @method getUserList
*/

userSelection(user) {
  for (var i = 0; i < this.userList.length; i++) {
    if (this.userList[i] != null) {
      if (user.userId == this.userList[i].userId) {
        this.userId = this.userList[i].userId;
      }
    }
  }
}

/** When select a role such as super admin or naac representative 
* @class ChapterAdminComponent
* @method roleSelection
*/

roleSelection(role) {
  if (role.roleName == "BPG Admin") {
    this.adminId = '3';
  }
  else if (role.roleName == "BPG Lead Admin") {
    this.adminId = '2';
  }
}

/** For site change from site list 
   * @class ChapterAdminComponent
   * @method siteChange
   * @returns Promise
   */
  siteChange(event) {
    this.clearError();
    this.selectedBpgId = null;
    this.selectedBpg= null;
    this.userFirstName=null;
    this.userId=null;
    this.selectedSiteId = event.siteId;
    this.bpgList = [];
    this.getBpgList();
  }
 /** For bpg change from bpg list 
   * @class ChapterAdminComponent
   * @method bpgChange
   * @returns Promise
   */

  bpgChange(event) {
    this.selectedBpgId=null;
    this.userFirstName=null;
    this.userId=null;
    this.selectedBpgId = event.bpgId;   
    this.getChapterIds();     
    this.getUserList();
  }

/** to add new admin
  * @class ChapterAdminComponent
  * @method onSubmit
  */
 onSubmit() {
  this.timeOutError = false;
  this.spinner.show();
  let data = {                        
    "createdBy": this.createdBy,
    "createdDateTime": this.createdDateTime,
    "isActive": true,
    "modifiedBy": this.modifiedBy,
    "modifiedDateTime": this.modifiedDateTime,
    "userId": this.userId,
    "userRoleMappingId": 0,
    "adminId": parseInt(this.adminId),
    "bpgId": this.selectedBpgId,
    "chapterId":this.chapterId
  }

  this.adminService.saveChapterAdmin(data).subscribe(data => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    if(data.message){ 
      this.errorMsg = data.message;
      this.alertFailure = true;
    }  
    else {
      this.alertSuccess = true;
    }
    
    this.listAdmins();
    this.getUserList();
    this.spinner.hide();
  },
  err => {
    console.log(JSON.stringify(err.value.message));
    if(err.value.statusText == ConstantValues.unknownError){
      this.timeOutError = true;
    }
  }); 
  //this.resetClick();

}

/**to delete admin
* @class ChapterAdminComponent
* @method delete
*/

delete(data) {
  this.clearError();
  this.method = "deleteAdmin";
  this.param = data;
  this.msg1 = "Are you sure you want to delete this admin ?";
}

deleteAdmin(data) {
  this.timeOutError = false;
  this.adminService.deleteChapterAdmin(data).subscribe(data => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.deleteSuccess = true;
    this.listAdmins();
    this.getUserList();   
  },
  err => {
    console.log(JSON.stringify(err.value.message));
    if(err.value.statusText == ConstantValues.unknownError){
      this.timeOutError = true;
    }
  });  
}

/** For filtering data by current page 
 * @class AdminComponent
 * @method pageChanged
 * @params event
 */
pageChanged(event) {
  this.clearError(); 
  this.LandingPaginationDTO.page = event - 1;
  this.currentPage = event;

  if ((this.currentPage * this.limit) < this.numberOfElements) {
    this.currentShowingElements = this.currentPage * this.limit;
  } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
    this.currentShowingElements = this.numberOfElements;
  }
  this.listAdmins();
}

  /** For sorting the table through columns
 * @class AdminComponent
 * @method sortMe
 */

public sortMe(sortingby) {
  this.clearError(); 
  if (this.LandingPaginationDTO.sortDirection == "ASC") {
    this.LandingPaginationDTO.sortDirection = "DESC";
    document.getElementById(sortingby + "1").classList.add("fading");
    document.getElementById(sortingby + "2").classList.remove("fading");
  } else {
    this.LandingPaginationDTO.sortDirection = "ASC";
    document.getElementById(sortingby + "2").classList.add("fading");
    document.getElementById(sortingby + "1").classList.remove("fading");
  }

  this.LandingPaginationDTO.sortProperty = sortingby;
  this.listAdmins();
}

   /** For searching the table through keywords
 * @class AdminComponent
 * @method searchMe
 */
searchMe() {
  this.clearError(); 
  this.spinner.show();
  this.searchKey = (this.searchKey) ? this.searchKey : '';
  this.LandingPaginationDTO.page = 0;
  this.LandingPaginationDTO.searchTerm = this.searchKey;
  this.currentPage = 1;
  this.listAdmins();
  this.spinner.hide();
}

  /** Confirm on save
   * @class AdminComponent
   * @method submit
   */
  submit(){

    if(this.selectedBpgId==null || this.selectedBpgId ==""){
      this.bpgNotSelected = true;     
      return;
    }
    if(this.userId == null || this.userId==""){
      this.clearError();
      this.userNotSelected = true;         
      return;
    }
    if(this.adminId == null || this.adminId=="" || this.roleName == null){
      this.clearError(); 
      this.roleNotSelected = true;           
      // document.getElementById("submitButton").removeAttribute('data-toggle');
      // document.getElementById("submitButton").removeAttribute('data-target');
      return;
    } 
    this.clearError(); 
    document.getElementById("submitButton").setAttribute('data-toggle','modal');
    document.getElementById("submitButton").setAttribute('data-target','#myModal');

    this.method = "onSubmit";
    this.param = '';
    this.msg1="Do you want to add admin ?";
  }

  reset(){

    this.method = "resetClick";
    this.param = '';
    this.msg1="Your current changes will be discarded. Do you want to continue ?";

  }
 /** Confirm on reset
   * @class AdminComponent
   * @method resetClick
   */
  resetClick(){
    this.roleName = null;
    this.userFirstName = null;
    this.selectedBpg= null;
    this.selectedBpgId=null;
    this.userId = null;
    this.adminId = null;
    this.clearError(); 
    this.searchKey=null;
    this.LandingPaginationDTO.searchTerm= null;
    this.getSiteName();  
    this.getBpgList();   
    this.listAdmins();
}

 /** For clearing errors
   * @class ChapterAdminComponent
   * @method clearError
   */
  clearError() {   
    this.bpgNotSelected = false; 
    this.userNotSelected = false;
    this.roleNotSelected = false;
    this.alertSuccess = false;
    this.alertFailure = false;
    this.deleteSuccess = false; 
    document.getElementById("submitButton").removeAttribute('data-toggle');
    document.getElementById("submitButton").removeAttribute('data-target');  
  }
}
